import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";
import AssignmentCard from "../../components/crm/AssignmentCard";
import TasksCard from "../../components/crm/TasksCard";
import ActivityTimeline from "../../components/crm/ActivityTimeline";
import { errMsg } from "../../components/crm/crmUtil";

const Rel = ({ title, rows, to, label, testId }) => (
  <section className="border border-erf-borderCream rounded bg-white p-4" data-testid={testId}>
    <h2 className="font-display font-semibold mb-2">{title} ({rows.length})</h2>
    <ul className="text-sm space-y-1">{rows.map((r) => <li key={r.id}>{to ? <Link to={to(r)} className="underline inline-flex min-h-[44px] items-center">{label(r)}</Link> : label(r)}</li>)}</ul>
  </section>
);

// B5 part 2b: contact (kind="contact") and account (kind="account") detail pages with owner, tasks and activity.
export default function CrmRecordPage({ kind }) {
  const { id } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const load = useCallback(() => api.get(`/sales/${kind}s/${id}`).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))), [kind, id]);
  useEffect(() => { load(); }, [load]);
  const rec = d?.[kind];
  const title = kind === "contact" ? [rec?.first_name, rec?.last_name].filter(Boolean).join(" ") : rec?.name;
  return (
    <AppShell title={title || (kind === "contact" ? "Contact" : "Account")} subtitle={kind === "contact" ? rec?.email : rec?.type}>
      <div className="mx-auto w-full max-w-[1100px] px-4 md:px-6 space-y-4" data-testid={`${kind}-page`}>
        {err && <p role="alert" className="text-sm text-red-700" data-testid={`${kind}-error`}>{err}</p>}
        {!d && !err && <p className="font-mono text-xs">Loading…</p>}
        {d && <>
          {kind === "contact" && d.account && <Link to={`/crm/accounts/${d.account.id}`} className="underline inline-flex min-h-[44px] items-center" data-testid="contact-account-link">Account: {d.account.name}</Link>}
          {kind === "account" && <div className="grid gap-4 md:grid-cols-3">
            <Rel title="Contacts" testId="account-contacts" rows={d.contacts} to={(c) => `/crm/contacts/${c.id}`} label={(c) => [c.first_name, c.last_name].filter(Boolean).join(" ") || c.email} />
            <Rel title="Opportunities" testId="account-opps" rows={d.opportunities} to={(o) => `/crm/opportunities/${o.id}`} label={(o) => `${o.name} · ${o.stage}`} />
            <Rel title="Projects" testId="account-projects" rows={d.projects} label={(p) => `${p.name} · ${p.status}`} />
          </div>}
          <AssignmentCard entity={kind} id={id} record={rec} onSaved={load} />
          <div className="grid gap-4 lg:grid-cols-2"><TasksCard entity={kind} id={id} /><ActivityTimeline entity={kind} id={id} /></div>
        </>}
      </div>
    </AppShell>
  );
}
